import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Select from "react-select";
import { api_path } from "../../shared.js";
import swal from "sweetalert";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Rating, { IconContainerProps } from "@mui/material/Rating";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
export function RatingForm() {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const StyledRating = styled(Rating)(({ theme }) => ({
    "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
      color: theme.palette.action.disabled,
    },
  }));
  const customIcons: {
    [index: string]: {
      icon: React.ReactElement,
      label: string,
    },
  } = {
    1: {
      icon: <SentimentVeryDissatisfiedIcon color="error" />,
      label: "Very Dissatisfied",
    },
    2: {
      icon: <SentimentDissatisfiedIcon color="error" />,
      label: "Dissatisfied",
    },
    3: {
      icon: <SentimentSatisfiedIcon color="warning" />,
      label: "Neutral",
    },
    4: {
      icon: <SentimentSatisfiedAltIcon color="success" />,
      label: "Satisfied",
    },
    5: {
      icon: <SentimentVerySatisfiedIcon color="success" />,
      label: "Very Satisfied",
    },
  };

  function IconContainer(props: IconContainerProps) {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
  }
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [getBusinessType, setBusinessType] = useState([]);
  const [businessTypeList, setBusinessTypeList] = useState([]);
  const [selectBusinessType, setSelectBusinessType] = useState([]);
  const [getShipper, setShipper] = useState([]);
  const [shipperList, setShipperList] = useState([]);
  const [selectShipper, setSelectShipper] = useState([]);

  const [getPol, setPol] = useState([]);
  const [polList, setPolList] = useState([]);
  const [selectPol, setSelectPol] = useState([]);

  const [getPod, setPod] = useState([]);
  const [podList, setPodList] = useState([]);
  const [selectPod, setSelectPod] = useState([]);
  const [selectPodString, setSelectPodString] = useState("");

  const [getCommodity, setCommodity] = useState([]);
  const [commodityList, setCommodityList] = useState([]);
  const [selectCommodity, setSelectCommodity] = useState([]);

  const [getContainer, setContainer] = useState([]);
  const [containerList, setContainerList] = useState([]);
  const [selectContainer, setSelectContainer] = useState([]);

  const [por, setPor] = useState("");
  const [qty, setQty] = useState("");
  const [weight, setWeight] = useState("");
  const [dimension, setDimension] = useState("");
  const [remark, setRemark] = useState("");
  const [targetRate, setTargetRate] = useState("");
  const [getCarrier, setCarrier] = useState([]);
  const [carrierList, setCarrierList] = useState([]);
  const [selectCarrier, setSelectCarrier] = useState([]);

  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);

  const [getStatus, setStatus] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const [subjectName, setSubjectName] = useState("");
  const [getDateStr, setDateStr] = useState(
    "Please click Search button to refresh data."
  );
  const [getSearchStatus, setSearchStatus] = useState(0);
  useEffect(() => {
    //run always
  });

  useEffect(() => {
    //run one time only
    fetchBusinessType();
    fetchShipper();
    fetchCommodity();
    fetchSale();
  }, []);
  useEffect(() => {
    //run when id Change value.
    if (id > 0) {
      setSubjectName("Edit Feedback");
      fetch(api_path + "/TS_SALE_INQUIRY.php?id=" + id)
        .then((res) => res.json())
        .then((res) => {
          const array = res;
          for (const i of array) {
            setSelectBusinessType(i.BUSINESS_ID);
            setBusinessType({
              TYPE_ID: i.TYPE_ID,
              TYPE_NAME: i.TYPE_NAME,
            });
            // console.log(i.CUSTOMER_NAME)
            setSelectShipper(i.CRM_CUSCODE);
            setShipper({
              CRM_CUSCODE: i.CRM_CUSCODE,
              CUSTOMER_NAME: i.CUSTOMER_NAME,
            });
            setSelectPol(i.POL);
            setPol({
              PORT_CODE: i.POL,
              PORT_CODE: i.POL,
            });
            //setSelectPod(i.POD);
            setPod({
              value: i.POD,
              label: i.POD,
            });
            setPor(i.POR);
            setCommodity(i.COMMODITY);
            setQty(i.QUANTITY);
            setContainer(i.CONTAINER_SIZE);
            setSelectContainer(i.CONTAINER_SIZE);

            setWeight(i.WEIGHT);
            setDimension(i.DIMENSION);
            setTargetRate(i.TARGET_RATE);
            setCarrier(i.CARRIER);
            console.log(i.INQUIRY_STATUS_ID);
            setSelectStatus(i.INQUIRY_STATUS_ID);
            //setStatus(i.INQUIRY_STATUS_ID);
            setStatus({
              value: i.INQUIRY_STATUS_ID,
              label: i.POD,
            });
            setSelectSale(i.SALESID);
            setSale({
              EmpEmail: i.SALESID,
              EmpEmail: i.SALESID,
            });
            setRemark(i.REMARK);
          }
        });
    } else {
      setSubjectName("New Feedback");
    }
  }, [id]);
  const fetchBusinessType = () => {
    axios
      .get(api_path + `/MS_INQUIRY_MASTER.php?type="BU"`)
      .then((response) => {
        setBusinessTypeList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleBusinessTypeChange = (obj) => {
    setSelectBusinessType(obj.TYPE_ID);
    setBusinessType({ TYPE_ID: obj.TYPE_ID, TYPE_NAME: obj.TYPE_NAME });
  };
  const fetchShipper = () => {
    axios
      .get(api_path + `/MS_CUSTOMER.php`)
      .then((response) => {
        setShipperList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleShipperChange = (obj) => {
    setSelectShipper(obj.CRM_CUSCODE);
    setShipper({
      CRM_CUSCODE: obj.CRM_CUSCODE,
      CUSTOMER_NAME: obj.CUSTOMER_NAME,
    });
  };
  useEffect(() => {
    const getPolDropdown = async () => {
      const resstate = await fetch(api_path + `/MS_ISO_PORT.php?GETALLPORT=1`);
      const getst = resstate.json();
      setPolList(await getst);
    };
    getPolDropdown().then();
  }, []);
  const handlePolChange = (obj) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectPol(Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []);
    setPol({
      value: obj.PORT_CODE,
      label: obj.PORT_CODE,
    });
  };

  useEffect(() => {
    const getPodDropdown = async () => {
      const resstate = await fetch(api_path + `/MS_ISO_PORT.php?GETALLPORT=1`);
      const getst = resstate.json();
      setPodList(await getst);
    };
    getPodDropdown().then();
  }, [selectPod]);
  const handlePodChange = (obj) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectPod(Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []);
    setPod({
      value: obj.PORT_CODE,
      label: obj.PORT_CODE,
    });
  };
  const fetchCommodity = () => {
    axios
      .get(api_path + `/MS_COMMODITY.php`)
      .then((response) => {
        setCommodityList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleCommodityChange = (obj) => {
    setSelectCommodity(obj.COMMODITY_NAME);
    setCommodity({
      COMMODITY_NAME: obj.COMMODITY_NAME,
      COMMODITY_NAME: obj.COMMODITY_NAME,
    });
  };

  const handleStatusChange = (obj) => {
    // setSelectStatus(obj.PORT_CODE);
    // setStatus({ PORT_CODE: obj.PORT_CODE, PORT_NAME: obj.PORT_CODE });
  };
  useEffect(() => {
    const getCarrierDropdown = async () => {
      const resstate = await fetch(api_path + `/BC_MS_CARRIER.php`);
      const getst = resstate.json();
      setCarrierList(await getst);
    };
    getCarrierDropdown().then();
  }, [selectCarrier]);
  const handleCarrierChange = (obj) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectCarrier(
      Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []
    );
    setCarrier({
      value: obj.CARRIER,
      label: obj.CARRIER,
    });
  };
  const fetchSale = () => {
    axios
      .get(api_path + `/sales.php`)
      .then((response) => {
        setSaleList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSaleChange = (obj) => {
    setSelectSale(obj.EmpEmail);
    setSale({ EmpEmail: obj.EmpEmail, EmpEmail: obj.EmpEmail });
  };
  const handleSubmit = (event) => {
    let id = 0;
    let USERID = "kornraphat.c@sinologistics.co.th";
    event.preventDefault();
    let methodKey = "";
    if (id > 0) {
      methodKey = "PUT";
      var data = {
        BUSINESS_ID: selectBusinessType,
        SHIPPER_NAME: selectShipper,
        POL: selectPol,
        POD: selectPod,
        POR: por,
        COMMODITY: selectCommodity,
        QUANTITY: qty,
        CONTAINER_SIZE: selectContainer,
        WEIGHT: weight,
        DIMENSION: dimension,
        TARGET_RATE: targetRate,
        CARRIER: selectCarrier,
        REQUEST_STATUS: selectStatus,
        REMARK: remark,
        SALESID: selectSale,
        USERID: USERID,
        DONE_BY: "",
        LAST_UPDATE: "",
        UPDATE_BY: "",
        INQUIRY_ID: id,
      };
    } else {
      methodKey = "POST";
      var data = {
        BUSINESS_ID: selectBusinessType,
        SHIPPER_NAME: selectShipper,
        POL: selectPol,
        POD: selectPodString,
        POR: por,
        COMMODITY: "",
        QUANTITY: qty,
        CONTAINER_SIZE: "",
        WEIGHT: weight,
        DIMENSION: dimension,
        TARGET_RATE: targetRate,
        CARRIER: "",
        REQUEST_STATUS: "",
        REMARK: remark,
        SALESID: "",
        USERID: "",
        INQUIRY_STATUS: "1",
      };
    }
    console.log(data);
    fetch(api_path + "/TS_SALE_INQUIRY.php", {
      method: methodKey,
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 1000,
          }).then(function () {
            //window.location = "./#/SaleInquiry?id=" + result["message"] + "&country_code=" +selectCountry;
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 1000,
          });
        }
      });
  };
  const options = [
    { value: "1", label: "Price" },
    { value: "2", label: "Schedule" },
    { value: "3", label: "Customer issue" },
    { value: "4", label: "Free time" },
  ];
  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <label className="head">{subjectName}</label>
      </Grid>

      <form onSubmit={handleSubmit}>
        <Grid container className="Box" spacing={2}>
          <Grid item xs={12} sm={12}>
            <label>Rating</label>
            <span className="red">*</span> &nbsp;&nbsp;&nbsp;
            <StyledRating
              name="highlight-selected-only"
              defaultValue={2}
              IconContainerComponent={IconContainer}
              getLabelText={(value: number) => customIcons[value].label}
              highlightSelectedOnly
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>Reason</label>
            <span className="red">*</span>
            <Select
              placeholder="Select"
              defaultValue={{ value: "1", label: "Price" }}
              value={getStatus}
              options={options}
              onChange={handleStatusChange}
              required
            />
          </Grid>

          <Grid item xs={12} sm={9}>
            <label>Comment</label>
            <TextField
              size="small"
              name="remark"
              fullWidth
              id="remark"
              variant="outlined"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Grid>

          <br />
          <Grid container className="Box" spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
              >
                Save
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                type="button"
                fullWidth
                variant="outlined"
                color="primary"
                onClick={goBack}
              >
                &larr; Go Back
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
